import { MDCDialog } from "@material/dialog";
import { loopThroughElements } from "./utils/loop-through-elements";

export class PopupManager {
    popups: Array<MDCDialog> = [];
    orphanedPopups: Array<MDCDialog> = [];
    autoShowEnabled = true;

    constructor() {
        this.initialize();
    }

    initialize = () => {
        this.autoShowEnabled = !document.querySelector('[data-disable-auto-popups]');
        loopThroughElements(document.querySelectorAll('.mdc-dialog.mdc-dialog--auto-open'), element => {
            const reference = MDCDialog.attachTo(element);
            const closeArray = element.getElementsByClassName('mdc-dialog__close');
            if (closeArray.length) {
                closeArray[0].addEventListener('click', () => reference.close());
            }
            if (this.autoShowEnabled) {
                reference.open();
            }
            if (element.id) {
                this.popups[element.id] = reference;
            } else {
                this.orphanedPopups.push(reference);
            }
        });
    }
}